var homeContext = {
    componentName: '@layout/Home'
};

export { homeContext };
